import { OpcoesExportacaoFolha as Opcoes } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Funcionario } from './funcionario'

export type SaldoFolha = {
    id: string
    codigoRubrica: string
    dataRescisao?: Date
    funcionarioId: number
    matricula: number
    nomeFuncionario: string
    nomeRubrica: string
    rubricaId: number
    valor: string
    Funcionario: Funcionario
}

export type TPagamentoFolha = {
    horasExtras: Opcoes
    horasFaltas: Opcoes
    /** Quantas horas extras serão pagas (HHH:mm) */
    horasExtrasPagar?: string
    /** Quais porcentagens serão pagas */
    porcentagensSelecionadas?: number[]
    /** Quantas horas faltas serão pagas (HHH:mm) */
    horasFaltasPagar?: string
}

export const ExportacaoFolhaSchema = z
    .object({
        horasExtras: z.coerce.number().min(1).max(3),
        horasFaltas: z.coerce.number().min(1).max(3),
        porcentagensSelecionadas: z.string().optional(),
        horasExtrasPagar: z.string().optional(),
        horasFaltasPagar: z.string().optional(),
    })
    .refine(
        data => {
            if (data.horasFaltas == Opcoes.DESCONTAR) {
                return /^\d{3}:\d{2}$/.test(data.horasFaltasPagar ?? '')
            }
            return true
        },
        {
            message: 'Horas faltas a pagar deve estar no formato HHH:mm',
            path: ['horasFaltasPagar'],
        },
    )
    .refine(
        data => {
            if (data.horasExtras == Opcoes.DESCONTAR) {
                return /^\d{3}:\d{2}$/.test(data.horasFaltasPagar ?? '')
            }
            return true
        },
        {
            message: 'Horas extras a pagar deve estar no formato HHH:mm',
            path: ['horasExtrasPagar'],
        },
    )
    .refine(
        data => {
            if (data.horasExtras != Opcoes.NADA) {
                return (
                    JSON.parse(data.porcentagensSelecionadas ?? '[]').length > 0
                )
            }
            return true
        },
        {
            message: 'Selecione pelo menos uma porcentagem de horas extras',
            path: ['porcentagensSelecionadas'],
        },
    )

const service = new ApiService<SaldoFolha>('integracao-folha')

export const integracaoFolha = Object.assign(service, {
    historico: new ApiService<SaldoFolha>('integracao-folha/historico'),
})
